module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore.svg?2e77549b52841d080978ecd1ddb9ff3c";